module.exports = __webpack_public_path__ + "img/info_msg.3609f325.png";